import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, filter, tap } from 'rxjs';
import { ExternalDataService } from '../external-data/external-data.service';
import { GooglePayService } from '../google-pay/google-pay.service';
import { ScriptLoaderService } from '../script-loader/script-loader.service';

@Injectable({
  providedIn: 'root',
})
export class ExpressService {
  private readonly APPLE_SCRIPT = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
  private readonly GOOGLE_SCRIPT = 'https://pay.google.com/gp/p/js/pay.js';

  public $isExpressEnabled = new BehaviorSubject(false);
  public $canDoApplePay = new BehaviorSubject(false);
  public $canDoGooglePay = new BehaviorSubject(false);

  constructor(
    private scriptLoaderService: ScriptLoaderService,
    private injector: Injector,
    private externalDataService: ExternalDataService
  ) {
    this.externalDataService.$useExpressCheckout
      .pipe(filter(use => use != this.$isExpressEnabled.getValue()))
      .pipe(tap(use => this.$isExpressEnabled.next(use)))
      .pipe(filter(use => use === true))
      .subscribe(() => this.initialise());
  }

  private initialise() {
    if (!this.scriptLoaderService.isLoaded(this.APPLE_SCRIPT)) {
      this.scriptLoaderService.load(this.APPLE_SCRIPT).then(() => this.initApple());
    }

    if (!this.scriptLoaderService.isLoaded(this.GOOGLE_SCRIPT)) {
      this.scriptLoaderService.load(this.GOOGLE_SCRIPT).then(() => this.initGoogle());
    }
  }

  private initApple() {
    this.$canDoApplePay.next(!!window.ApplePaySession?.applePayCapabilities('sfey'));
  }

  private initGoogle() {
    this.injector.get(GooglePayService).$isReadyToPay.subscribe((ready) => this.$canDoGooglePay.next(ready));
  }
}
